import React, { useEffect, useState } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices } from 'hook/services'
import Select from 'react-select'

const FeaturesList = [
  { label: 'Apps', value: 'Apps' },
  { label: 'Media Library', value: 'Media Library' },
  { label: 'Check List', value: 'Check List' },
  { label: 'Change Log', value: 'Change Log' },
  { label: 'Knowledge base', value: 'Knowledge base' },
  { label: 'White Board', value: 'White Board' },
  { label: 'Saas Configurator', value: 'Saas Configurator' },
  { label: 'Stripe Connection', value: 'Stripe Connection' },
]
const EditModal = ({ data, handleRefresh }) => {
  const AppService = useAppServices()
  const [features, setFeatures] = useState([])
  const [openEditProduct, setOpenEditProduct] = useState(false)
  const [processing, setProcessing] = useState(false)

  const handleModal = () => {
    setOpenEditProduct(true)
  }

  const closeEditProduct = () => {
    setOpenEditProduct(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)
    const payload = {
      _id: data._id,
      name: e.target.name.value,
      features: features,
    }

    const { response } = await AppService.partner_keys.update({ payload })

    if (response) {
      setProcessing(false)
      setOpenEditProduct(false)
      handleRefresh()
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="info" size="small" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox
            component="form"
            onSubmit={handleSubmit}
            role="form"
            sx={style}
            encType="multipart/form-data"
          >
            <MDTypography variant="h5" mb={2}>
              Edit Keys
            </MDTypography>
            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput defaultValue={data?.name} label="Name" name="name" fullWidth required />
            </MDBox>
            <MDBox mb={2} sx={{ fontSize: '14px' }}>
              <MDTypography variant="button">Features</MDTypography>
              <Select
                isMulti
                options={FeaturesList}
                defaultValue={data?.features}
                onChange={(e) => setFeatures(e)}
                name="features"
              />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default EditModal
